module.exports = __webpack_public_path__ + "img/logoo-w.175f3d71.svg";